/**
 * @file Selfie upload examples component.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import SideNav from '../global/Sidenav';
import Button from '../global/Button';
import { folderHasChildrenByTotals } from '../../util/album-folder';
import OpenFolderIcon from '../icons/OpenFolderIcon';
import AngleLeftIcon from '../icons/AngleLeftIcon';

class DiscoverAlbumFolderBrowse extends Component {
  static propTypes = {
    toggleComponent: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.string,
    ]).isRequired,
    albumFolder: PropTypes.shape({
      id: PropTypes.string.isRequired,
      children: PropTypes.shape({
        album_folders: PropTypes.shape({
          records: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string.isRequired,
              children: PropTypes.shape({
                album_folders: PropTypes.shape({
                  records: PropTypes.arrayOf(
                    PropTypes.shape({
                      id: PropTypes.string.isRequired,
                    }),
                  ),
                }),
              }),
            }),
          ),
        }),
      }),
    }),
    loading: PropTypes.bool,
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  state = {
    isOpen: false,
  };

  toggleIsOpen = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  };

  renderFolderChildren = (folder, level = 0, maxLevel = 2) => {
    const { history } = this.props;

    const children = get(folder, 'children');
    if (!children) {
      return null;
    }

    const albumFolders = get(children, 'album_folders.records') || [];
    const albums = get(children, 'albums.records') || [];

    return (
      <Fragment>
        {albumFolders.map(albumFolder =>
          folderHasChildrenByTotals(albumFolder) ? (
            <Fragment key={albumFolder.id}>
              <Button
                onClick={() => {
                  history.push(
                    `/discover/album-folder/${albumFolder.id}/select`,
                  );
                  this.toggleIsOpen();
                }}
                btnStyle="link"
                className="text-bold text-dark d-block"
              >
                {albumFolder.name}
              </Button>
              {level !== maxLevel && folderHasChildrenByTotals(albumFolder) && (
                <div className="discover-browse-folder-children">
                  {this.renderFolderChildren(albumFolder, level + 1)}
                </div>
              )}
            </Fragment>
          ) : undefined,
        )}

        {albums.map(album => (
          <Button
            key={album.id}
            onClick={() => {
              history.push(
                `/discover/album-folder/${album.album_folder.id}/select`,
              );
              this.toggleIsOpen();
            }}
            btnStyle="link"
            className="text-bold d-block"
          >
            {album.name}
          </Button>
        ))}
      </Fragment>
    );
  };

  render() {
    const { toggleComponent, albumFolder, loading } = this.props;

    if (loading) {
      return null;
    }

    const { isOpen } = this.state;

    return (
      <Fragment>
        <Button btnStyle="reset" onClick={this.toggleIsOpen}>
          {toggleComponent}
        </Button>

        <SideNav isOpen={isOpen} onClickOutside={this.toggleIsOpen}>
          <div className="d-flex flex-column mb-2">
            <Button
              btnStyle="link"
              onClick={this.toggleIsOpen}
              className="mr-auto text-extra-bold mb-4"
            >
              <AngleLeftIcon color="#0d84fe" height={12} className="mr-1" />{' '}
              Hide
            </Button>
            <h3 className="d-flex align-items-center mb-0">
              <OpenFolderIcon
                color="#646e71"
                width={32}
                height={20}
                className="mr-1"
              />
              Select an Album:
            </h3>
          </div>

          <div className="discover-browse-content">
            {this.renderFolderChildren(albumFolder)}
          </div>
        </SideNav>
      </Fragment>
    );
  }
}

export default DiscoverAlbumFolderBrowse;
